module.exports = {"version":"2026.715.0"}


//////////////////
// WEBPACK FOOTER
// ./src/version.json
// module id = 2950
// module chunks = 3